import { DeleteTopicsFlow } from "app/pages/activation/components/Topics/Modal/Flow/DeleteTopicsFlow/DeleteTopicsFlow";
import { AddTopicsFlow } from "app/pages/activation/components/Topics/Modal/Flow/AddTopicFlow/AddTopicsFlow";
import { ModalFlow } from "app/pages/activation/components/Topics/Modal/types";

import { Advanced } from "./Advanced/Advanced";
import { Collision } from "./Collision/Collision";
import type { FlowSchema } from "./type";

export const Flow = ({ flow, isShared, topicId, onDelete }: FlowSchema) => {
    if (flow === ModalFlow.Add) {
        return <AddTopicsFlow />;
    }

    if (flow === ModalFlow.Advanced) {
        return <Advanced />;
    }

    if (flow === ModalFlow.Collision) {
        return <Collision />;
    }

    if (flow === ModalFlow.Delete || flow === ModalFlow.DeleteShared) {
        return (
            <DeleteTopicsFlow
                topicId={topicId}
                isShared={isShared}
                onDelete={onDelete}
            />
        );
    }
};

Flow.displayName = "TopicModalFlow";
